import { render, staticRenderFns } from "./app-ocr.vue?vue&type=template&id=2b499c0d"
import script from "./app-ocr.vue?vue&type=script&lang=js"
export * from "./app-ocr.vue?vue&type=script&lang=js"
import style0 from "./app-ocr.vue?vue&type=style&index=0&id=2b499c0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports